export default "__VITE_ASSET__BpzRAp4$__"